<template>
    <header id="app-header" class="flex h-[55px] sm:h-[70px] items-center justify-between">
        <div>
            <img src="/images/campaigns/logo.svg" class="w-[100px] sm:w-[132px]" alt="Nova logo">
        </div>

        <div class="hidden lg:flex items-center">
            <img src="/images/campaigns/google-logo-icon.svg" class="w-[24px] mr-2" alt="Google logo icon" />

            <img src="/images/campaigns/rating-stars.svg" alt="Google's rating stars" />

            <p class="text-[#1B2F51] leading-snug text-[14px] ml-2">
                {{ $t("campaign_version_one.Rated") }} <span class="font-semibold">4.9</span> {{ $t("campaign_version_one.out of 5 on") }} <span class="font-semibold">Google</span>
            </p>
        </div>

        <div>
            <a href="tel:052519746">
                <div class="flex items-center">
                    <img src="/images/campaigns/phone.svg" class="w-[14px] mb-0.5 sm:w-[18px]" alt="Phone icon" />

                    <span class="text-[#1EB26D] text-[16px] sm:text-[20px] font-semibold sm:font-bold ml-2">
                        {{ $t("campaign_version_one.Nova phone number") }}
                    </span>
                </div>
            </a>
        </div>
    </header>
</template>

<style scoped>
#app-header {
    background-color: #fff;
}

@media screen and (min-width: 640px) {
    #app-header {
        background-color: transparent;
    }
}
</style>
